export var PaginationVariant;

(function (PaginationVariant) {
  PaginationVariant["compact"] = "compact";
  PaginationVariant["extended"] = "extended";
  PaginationVariant["minimal"] = "minimal";
  PaginationVariant["minimalWithLabels"] = "minimalWithLabels";
  PaginationVariant["normal"] = "normal";
})(PaginationVariant || (PaginationVariant = {}));

export var paginationVariants = ['compact', 'extended', 'minimal', 'minimalWithLabels', 'normal'];
export var StartEllipsis = 'start-ellipsis';
export var EndEllipsis = 'end-ellipsis';